import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {colors} from 'shells/colors/colors';
import {ErrorCircleIcon} from 'shells/icon';
import {Body} from 'shells/typography/body';

import {getBannerSaveText} from '../helpers';

type Props = {
    // @ts-expect-error
    activity: Activity;
    onCancel: () => void;
    onSave: () => void;
    isSaving: boolean;
    isCancelDisabled: boolean;
};

export function ChangedBanner(props: Props) {
    const bodyText = getBannerSaveText(props.activity);

    return (
        <>
            <div className='flex gap-8 align-center'>
                <ErrorCircleIcon
                    size={14}
                    style={{color: colors.orangeAttention}}
                    alignCenter={true}
                />
                <Body>{bodyText}</Body>
            </div>
            <div className='flex gap-8'>
                <Button
                    size='big'
                    variant='text-secondary'
                    onClick={props.onCancel}
                    disabled={props.isCancelDisabled}
                >
                    Cancel
                </Button>
                <SaveButton
                    buttonText='Save changes'
                    size='big'
                    isSaving={props.isSaving}
                    // @ts-expect-error
                    onClick={props.onSave}
                />
            </div>
        </>
    );
}
